import Vue from "vue";
import GutenbergOneRobotAPI from "./GutenbergOneRobotAPI";

Vue.use(GutenbergOneRobotAPI);